<div class="container mt-3 mx-auto">
  <div class="alert alert-info" *ngIf="msgSemResultado">
      Não foram encontradas habilitações com os filtros informados.
  </div>

  <div *ngIf="habilitacoes && habilitacoes.length">
      <div class="d-flex justify-content-end">
          <button [disabled]="habilitacoes.length == 0" class="btn btn-secondary m-0" type="button" (click)="btnExportarHabilitacoes()"
          placement="top" ngbTooltip="Exporta todas as habilitações alternativas listadas">
          <i class="fa fa-file"></i> Exportar habilitações</button>
      </div>
      <div class="letra-miuda">atualizado em: {{ dataHoraResultado }}</div>
      <bn-paginacao
          [total]="atributosPaginacao.count"
          [tamanhoPagina]="atributosPaginacao.pageSize" [numPagina]="atributosPaginacao.page"
          [opcoesTamanhoPagina]="opcoesPaginacao" (aoMudar)="mudancaPagina($event)">
          <div class="table-responsive">
              <table class="table table-hover cursor-pointer">
                  <thead>
                      <tr class="text-nowrap">
                          <th id="col-agente" scope="col">
                              <bn-ordenacao
                                  [ordenacao]="atributosOrdenacao"
                                  [atributo]="'agenteFinanceiro.sigla'"
                                  [nomeAtributoExibicao]="'Agente Financeiro'"
                                  (aoClickar)="mudancaOrdenacao($event)">
                              </bn-ordenacao>
                          </th>

                          <th id="col-data-inicio" scope="col" class="text-center">
                              <bn-ordenacao
                                  [ordenacao]="atributosOrdenacao"
                                  [atributo]="'valorLimite'"
                                  [nomeAtributoExibicao]="'Valor Limite R$'"
                                  (aoClickar)="mudancaOrdenacao($event)">
                              </bn-ordenacao>
                          </th>

                          <th id="col-data-fim" scope="col" class="text-center">
                              <bn-ordenacao
                                  [ordenacao]="atributosOrdenacao"
                                  [atributo]="'dataInicio'"
                                  [nomeAtributoExibicao]="'Data Início'"
                                  (aoClickar)="mudancaOrdenacao($event)">
                              </bn-ordenacao>
                          </th>

                          <th id="col-motivo" scope="col" class="text-center">
                              <bn-ordenacao
                                  [ordenacao]="atributosOrdenacao"
                                  [atributo]="'dataMaximaValidade'"
                                  [nomeAtributoExibicao]="'Data Máxima da Validade'"
                                  (aoClickar)="mudancaOrdenacao($event)">
                              </bn-ordenacao>
                          </th>

                          <th id="col-motivo" scope="col" class="text-end">
                              <bn-ordenacao
                                  [ordenacao]="atributosOrdenacao"
                                  [atributo]="'dataSuspensao'"
                                  [nomeAtributoExibicao]="'Data Suspensão'"
                                  (aoClickar)="mudancaOrdenacao($event)">
                              </bn-ordenacao>
                          </th>

                          <th id="col-motivo" scope="col">
                              <bn-ordenacao
                                  [ordenacao]="atributosOrdenacao"
                                  [atributo]="'situacao'"
                                  [nomeAtributoExibicao]="'Situação'"
                                  (aoClickar)="mudancaOrdenacao($event)">
                              </bn-ordenacao>
                          </th>

                      </tr>
                  </thead>

                  <tbody>
                      <ng-container *ngFor="let habilitacao of habilitacoes; let i = index">
                          <tr *ngIf="podeCadastrarHabilitacao && habilitacao.situacao != 'SUSPENSO'; else naoPodeCadastrarEditar"
                              (mouseenter)="hover(i)"
                              (mouseleave)="hoverClean()"
                              [routerLink]="['/habilitacao/alternativa/', habilitacao.agenteFinanceiro.id]">
                              <td>{{ habilitacao.agenteFinanceiro?.sigla?.toUpperCase() }}</td>
                              <td class="text-end">{{ habilitacao.valorLimite | bnMask: 'MOEDA' }}</td>
                              <td class="text-center">{{ habilitacao.dataInicio | date: 'dd/MM/yyyy' }}</td>
                              <td class="text-center">{{ habilitacao.dataMaximaValidade | date: 'dd/MM/yyyy' }}</td>
                              <td class="text-center">{{ habilitacao.dataSuspensao | date: 'dd/MM/yyyy' }}</td>
                              <td class="text-center">{{ habilitacao.situacao }}
                                <i *ngIf="rowHovered === i && habilitacao.situacao === 'INATIVO'" 
                                    class="fa fa-trash cursor-pointer text-danger ms-4" 
                                    (click)="modalConfirmarExclusao($event, habilitacao.id)"
                                    placement="left-center" 
                                    ngbTooltip="Excluir registro da habilitação alternativa">
                                </i>
                                <i *ngIf="rowHovered === i && habilitacao.situacao != 'SUSPENSO'" 
                                    class="fa fa-pen cursor-pointer text-primary ms-4" 
                                    placement="left-center" 
                                    ngbTooltip="Editar habilitação alternativa">
                                </i>
                              </td>
                          </tr>
                          <ng-template #naoPodeCadastrarEditar>
                              <tr>
                                <td>{{ habilitacao.agenteFinanceiro?.sigla?.toUpperCase() }}</td>
                                <td class="text-end">{{ habilitacao.valorLimite | bnMask: 'MOEDA' }}</td>
                                <td class="text-center">{{ habilitacao.dataInicio | date: 'dd/MM/yyyy' }}</td>
                                <td class="text-center">{{ habilitacao.dataMaximaValidade | date: 'dd/MM/yyyy' }}</td>
                                <td class="text-center">{{ habilitacao.dataSuspensao | date: 'dd/MM/yyyy' }}</td>
                                <td class="text-center">{{ habilitacao.situacao }}</td>
                              </tr>
                          </ng-template>
                      </ng-container>
                  </tbody>

              </table>
          </div>
      </bn-paginacao>

      <ng-template #msgTemplateExcluir>
        <span 
          >Esta ação irá EXCLUIR a linha selecionada. </span>
        <br />
        <br />
        Você confirma?
        <br />
      </ng-template>
      <ng-template #botoesPersonalizadosExcluir>
        <button class="btn btn-md btn-success" (click)="excluir()">
          Sim
        </button>
        <button class="btn btn-md btn-danger" (click)="dismissModal()">
          Não
        </button>
      </ng-template>

  </div>
</div>
